import authService from "../AuthService";
import {Redirect} from "react-router-dom";
import React from 'react';

const checkCapitaine = (Component) => {
    return class extends React.Component {
        state = { allowed: false, loading: true };

        async componentDidMount() {
            const res = await authService.getUserById();
            const isCapitaine = res.data.data.capitaine === "oui";

            this.setState({
                allowed: !isCapitaine,
                loading: false
            });
        }

        render() {
            const { allowed, loading } = this.state;

            if (loading) return null;

            if (!allowed) {
                // redirect to home or reservations
                return <Redirect to="/admin/reservations" />;
            }

            return <Component {...this.props} />;
        }
    };
};

export default checkCapitaine;

